import { Image, Box, Heading, Text } from "@chakra-ui/react";
import React from "react";
import help from "../../assets/helpCenter.png";
const HelpCenter = () => {
  return (
    <Box w={"100%"} textAlign={"left"}>
      <Image src={help} w={"100%"} />

      <Box w={{ md: "70%", base: "100%" }} px={10}>
        <Heading color={"#3C375F"} mt={5} className="oswald-font">
          Help center
        </Heading>
        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={20}
          mt={4}
        >
          Frequently Asked Questions (FAQs) - Wishfy
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
        >
          Welcome to Wishfy's FAQ page! We're here to answer your questions and
          provide you with all the information you need about our wide range of
          products and services, including free digital cards, high-quality
          low-cost pots, home decor, plants, and more. If you can't find the
          answer you're looking for, feel free to reach out to our friendly
          customer support team.
        </Text>
        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={20}
          mt={4}
        >
          General Questions:
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          1. What is Wishfy?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          {" "}
          - Wishfy is your one-stop destination for a variety of products and
          services, including free digital cards for all occasions, beautiful
          home decor, plants, and a wide range of budget-friendly gifts.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          2. How can I contact Wishfy's customer support?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - You can reach our customer support team by sending an email to
          support@wishfy.io or our contact us page.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          3. Do you provide custom cards for individual users?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - Yes, we offer on-demand custom cards for individual users. Whether
          it's a personalized birthday card, wedding invitation, or any other
          special occasion, we've got you covered.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          4. Can I order bulk gifts from Wishfy?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - Absolutely! We offer bulk gifts for various events, such as
          corporate gifting, weddings, and more. Contact our support team to
          discuss your bulk order requirements.
        </Text>
        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={20}
          mt={5}
        >
          Digital Cards:
        </Text>
        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          5. Are the digital cards really free?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - Yes, our digital cards are completely free. You can choose from a
          wide range of beautifully designed cards for all occasions without any
          cost.
        </Text>
        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          6. How do I send a digital card from Wishfy?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - Sending a digital card is easy. Simply select a card, personalize
          your message, and send it to your recipient via email, Whatsapp or
          share the link.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={20}
          mt={5}
        >
          Home Decor, Pots, and Plants:
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          7. What types of home decor products do you offer?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - We offer a variety of home decor items, including vases, wall art,
          candles, and more. Explore our collection to find the perfect decor
          for your space.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          8. Tell me more about your plant selection.
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - Our plants are carefully curated to provide you with healthy and
          beautiful options. We offer a variety of indoor and outdoor plants to
          suit your preferences.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          9. Are the pots available for sale too?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - Yes, we provide a range of pots to complement your plant choices.
          You can find high-quality pots for your indoor and outdoor needs at
          budget-friendly prices.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={20}
          mt={5}
        >
          Ordering and Shipping:
        </Text>
        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          10. How can I place an order with Wishfy?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - To place an order, simply browse our website, choose your desired
          products, add them to your cart, and follow the easy checkout process.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          11. Do you ship to locations outside India?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - At the moment, we primarily cater to customers in India. However,
          please contact us for special requests or inquiries regarding
          international shipping.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          12. What are the shipping costs?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - Shipping costs may vary based on your location and the products you
          order. You can find detailed shipping information during the checkout
          process.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={20}
          mt={5}
        >
          Returns and Refunds:
        </Text>
        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          13. What is your return policy?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - We have a hassle-free return policy. If you're not satisfied with
          your purchase, please refer to our Return Policy for guidance.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          14. How long does it take to process refunds?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - We aim to process refunds as quickly as possible, typically within
          14 days once we receive the returned items.
        </Text>

        <Text
          className="oswald-font"
          color={"#200E32"}
          fontWeight={"bold"}
          fontSize={18}
          mt={4}
        >
          15. What if I receive damaged items?
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"14px"}
          mt={2}
          lineHeight={1.2}
        >
          - We take utmost care in packaging, but if you receive damaged items,
          please contact our customer support team immediately. We'll assist you
          with the next steps. Please refer to return & refund policy for more
          details.
        </Text>
        <Text
          className="lato-font"
          color={"#200E32"}
          fontSize={"16px"}
          mt={10}
          lineHeight={1.2}
          fontWeight="regular"
          mb={20}
        >
          At Wishfy, we strive to make your experience enjoyable and convenient.
          If you have any more questions or need assistance with anything, don't
          hesitate to reach out to us. Your satisfaction is our top priority.
        </Text>
      </Box>
    </Box>
  );
};

export default HelpCenter;
